import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { todos } from "./todos";

export default function Page() {
  return (
    <div className="gap-4 h-full w-full overflow-hidden bg-blue-500">
      <div className="p-4 gap-4 w-full h-full columns-4 overflow-hidden">
        {todos.map((item, index) => (
          <Card key={`${item.task}-${index}`} className="break-inside-avoid-column mb-4">
            <CardHeader>
              <CardTitle className="text-xl">{item.task}</CardTitle>
            </CardHeader>
            <CardContent>
              <strong>Tags:</strong>{" "}
              {item.tags.map((tag, tagIndex) => (
                <Badge key={`${tag}-${tagIndex}`} className="px-2 m-2">
                  {tag.toUpperCase()}
                </Badge>
              ))}
              {item.description && (
                <>
                  <br />
                  <strong>Description:</strong> {item.description}
                </>
              )}
              {item.example_data && (
                <>
                  <br />
                  <strong>Example Data:</strong>{" "}
                  <pre>{JSON.stringify(item.example_data, null, 2)}</pre>
                </>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
